var RefinementContextLogger, RefinementContextLoggerDesktop,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RefinementContextLogger = require('./rcl');

RefinementContextLoggerDesktop = (function(superClass) {
  var dealsSearch, paginatedDealsBuilder, selectors, sortsApp;

  extend(RefinementContextLoggerDesktop, superClass);

  function RefinementContextLoggerDesktop() {
    return RefinementContextLoggerDesktop.__super__.constructor.apply(this, arguments);
  }

  sortsApp = void 0;

  dealsSearch = void 0;

  paginatedDealsBuilder = void 0;

  selectors = {
    CARD: '.card-ui',
    PAGE_CURRENT: '.pagination_links li.box',
    PAGE_DEALCOUNT: '.pagination .results',
    SORTS_DROPDOWN: '#grpn-sorts-select'
  };

  RefinementContextLoggerDesktop.prototype.events = {
    'click .card-ui a': '_addLoggerEvent'
  };

  RefinementContextLoggerDesktop.prototype.initialize = function(config) {
    RefinementContextLoggerDesktop.__super__.initialize.call(this, config);
    return this.refinementUIAppInstance = config.refinementUIAppInstance, config;
  };

  RefinementContextLoggerDesktop.prototype.setSortsApp = function(sorts) {
    return sortsApp != null ? sortsApp : sortsApp = sorts;
  };

  RefinementContextLoggerDesktop.prototype.setDealsSearch = function(search) {
    return dealsSearch = search;
  };

  RefinementContextLoggerDesktop.prototype.setPaginatedDealsBuilder = function(paginatedBuilder) {
    return paginatedDealsBuilder = paginatedBuilder;
  };

  RefinementContextLoggerDesktop.prototype._getDealAt = function(index) {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getDealAt(index);
    }
    if (dealsSearch != null) {
      return dealsSearch.getDealAt(index);
    }
    return {};
  };

  RefinementContextLoggerDesktop.prototype._addLoggerEvent = function(event) {
    var deal, index, ref;
    if (this._logDealAndCard) {
      ref = this._getDealAt($(event.currentTarget).parent(selectors.CARD).index()), deal = ref.deal, index = ref.index;
      this._currentDeal = deal;
      this._currentIndex = index + 1;
    }
    return RefinementContextLoggerDesktop.__super__._addLoggerEvent.call(this, event);
  };

  RefinementContextLoggerDesktop.prototype._getEventMeta = function(event) {
    var eventDetails;
    eventDetails = RefinementContextLoggerDesktop.__super__._getEventMeta.call(this, event);
    eventDetails.pagination.offset = this._getOffset();
    eventDetails.pagination.count = this._getDealsCount();
    return eventDetails;
  };

  RefinementContextLoggerDesktop.prototype._getSort = function() {
    if ((sortsApp != null ? sortsApp.sortToggleView : void 0) != null) {
      return sortsApp.sortToggleView.$el.val();
    }
    return this.$el.find(selectors.SORTS_DROPDOWN).val();
  };

  RefinementContextLoggerDesktop.prototype._getDealId = function() {
    return this._currentDeal.permalink;
  };

  RefinementContextLoggerDesktop.prototype._getDealUuid = function() {
    return this._currentDeal.uuid;
  };

  RefinementContextLoggerDesktop.prototype._getDealHref = function() {
    return this._currentDeal.dealShowUrl;
  };

  RefinementContextLoggerDesktop.prototype._getDealCategorization = function() {
    return this._currentDeal.categorization;
  };

  RefinementContextLoggerDesktop.prototype._getDealReviewInfo = function() {
    var productReviews, ratingCount;
    productReviews = this._currentDeal.productReviews;
    if (productReviews == null) {
      return;
    }
    ratingCount = productReviews.ratingCount || {};
    return {
      averageRating: ratingCount.averageRating || 0,
      ratingCount: ratingCount.countNumber || 0,
      reviewCount: productReviews.reviewCount || 0
    };
  };

  RefinementContextLoggerDesktop.prototype._getCardPosition = function() {
    return this._currentIndex;
  };

  RefinementContextLoggerDesktop.prototype._getCategoryHierarchy = function() {
    var categoryLogEntry, currentCategory, currentDepth, ref, ref1, selectedRefinements;
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    currentCategory = selectedRefinements != null ? selectedRefinements.category.selectedValues[0] : void 0;
    categoryLogEntry = RefinementContextLoggerDesktop.__super__._getCategoryHierarchy.call(this);
    while (currentCategory != null) {
      categoryLogEntry.id = currentCategory.name;
      currentDepth = ++categoryLogEntry.level;
      categoryLogEntry["category" + currentDepth] = currentCategory.name;
      currentCategory = (ref1 = currentCategory.selectedValues) != null ? ref1[0] : void 0;
    }
    return categoryLogEntry;
  };

  RefinementContextLoggerDesktop.prototype._getCurrentPageNumber = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getPageNumber();
    }
    if (dealsSearch != null) {
      return dealsSearch.getPageNumber();
    }
    return parseInt(this.$el.find(selectors.PAGE_CURRENT).text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getOffset = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getStartingIndex();
    }
    if (dealsSearch != null) {
      return dealsSearch.getStartingIndex();
    }
    return parseInt(this.$el.find(selectors.PAGE_DEALCOUNT).text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getDealsCount = function() {
    var range;
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getDealsCount();
    }
    if (dealsSearch != null) {
      return dealsSearch.getDealsCount();
    }
    range = this.$el.find(selectors.PAGE_DEALCOUNT).text().split(' of')[0].trim().split(' - ');
    return range[1] - range[0] + 1;
  };

  RefinementContextLoggerDesktop.prototype._getRefinements = function() {
    var friendlyNameShort, i, len, name, ref, ref1, refinementKey, refinementList, selectedRefinements, selectedValues;
    refinementList = RefinementContextLoggerDesktop.__super__._getRefinements.call(this);
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    for (refinementKey in selectedRefinements) {
      selectedValues = selectedRefinements[refinementKey].selectedValues;
      if (refinementKey !== 'category') {
        for (i = 0, len = selectedValues.length; i < len; i++) {
          ref1 = selectedValues[i], name = ref1.name, friendlyNameShort = ref1.friendlyNameShort;
          refinementList.push({
            filter: refinementKey,
            uuid: name,
            value: friendlyNameShort
          });
        }
      }
    }
    return refinementList;
  };

  return RefinementContextLoggerDesktop;

})(RefinementContextLogger);

module.exports = RefinementContextLoggerDesktop;

//# sourceMappingURL=data:application/json;base64,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
